/**
 * Wrapper over window.fetch that expects/returns JSON
 */
import { NetworkError } from "../shared/beam-errors";
import { logger } from "../shared/logger";
import { version as pkgVersion } from "../../package.json";

export async function fetchJson<T = unknown>(url: RequestInfo, options?: RequestInit): Promise<T> {
  const fetchOptions = {
    method: "GET",
    ...options,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Beam-Client": "WebSDK",
      "X-Beam-Client-Version": pkgVersion,
      ...options?.headers,
    },
    preflightContinue: true,
    mode: options?.mode || "cors",
    body: options?.body != null ? options.body : undefined,
  };

  // This can throw a TypeError based on network conditions
  const response = await fetch(url, fetchOptions);
  let body;
  let text;
  // This can throw a SyntaxError if response payload is malformed JSON
  try {
    text = await response.text();
    if (text) {
      // (response can be empty)
      body = JSON.parse(text);
    }
  } catch (err) {
    console.error(err);
    if (err instanceof SyntaxError) {
      const error = new NetworkError(response, body, `Response invalid. Expected JSON. Received: "${text}"`);
      logger.error(error);
      throw error;
    }
    throw err;
  }
  // Translate 4xx, 5xx status to runtime error
  if (!response.ok) {
    const error = new NetworkError(response, body, "Response was not OK");
    logger.error(error);
    throw error;
  }

  return body;
}
